const contents = [
  {
    title: 'MJFとは',
    href: 'about'
  },
  {
    title: '出場者',
    href: 'players'
  },
  {
    title: '審査基準',
    href: 'criterion'
  },
  {
    title: '審査員',
    href: 'judges'
  },
  {
    title: 'ゲストステージ',
    href: 'guests'
  },
  {
    title: 'お知らせ',
    href: 'notice'
  },
  {
    title: 'アクセス',
    href: 'access'
  },
  {
    title: 'お問い合わせ',
    href: 'contact'
  }
]

const criterion = [
  {
    name: '技術',
    description: '<span class="marker-line">ジャグリングのルーティンとしての難易度</span>を評価します。'
  },
  {
    name: '完成度',
    description: '<span class="marker-line">ミスやドロップの少なさ、技の安定性</span>を評価します。'
  },
  {
    name: '構成演出',
    description: '演技の構成や照明効果など、<span class="marker-line">演技全体としての演出</span>を評価します。'
  },
  {
    name: 'エンターテインメント性',
    description: '観客の盛り上がりなど、<span class="marker-line">ショーとしての側面</span>を評価します。'
  }
]

const players = {
  junior: [
    {
      id: 'a1',
      name: 'なかやま',
      instrument: 'スタッフ',
      image: 'https://i.imgur.com/P9SYt9l.png'
    },
    {
      id: 'a2',
      name: '横田 大輝',
      instrument: 'けん玉',
      image: 'https://i.imgur.com/bwhBkMR.png',
      prize: '2位'
    },
    {
      id: 'a3',
      name: '徳永 遥杜',
      instrument: 'ボール',
      image: 'https://i.imgur.com/WrTvaYf.jpg'
    },
    {
      id: 'a4',
      name: '山本 涼太郎',
      instrument: 'シガーボックス',
      image: 'https://i.imgur.com/bNEmPpp.png',
      prize: '3位'
    },
    {
      id: 'a5',
      name: 'そちろー',
      instrument: 'デビルスティック',
      image: 'https://i.imgur.com/eyMgq27.png',
      prize: '1位'
    },
    {
      id: 'a6',
      name: '小村 大樹',
      instrument: 'ディアボロ',
      image: 'https://i.imgur.com/eKL3doW.png'
    }
  ],
  senior: [
    {
      id: 'b1',
      name: '山内',
      instrument: 'ボール',
      image: 'https://i.imgur.com/WrTvaYf.jpg'
    },
    {
      id: 'b2',
      name: '松原 丈二',
      instrument: 'けん玉',
      image: 'https://i.imgur.com/bwhBkMR.png'
    },
    {
      id: 'b3',
      name: '遠藤 守琉',
      instrument: 'ディアボロ、ヨーヨー',
      image: 'https://i.imgur.com/eKL3doW.png'
    },
    {
      id: 'b4',
      name: '岡井 悠斗',
      instrument: 'シガーボックス',
      image: 'https://i.imgur.com/bNEmPpp.png'
    },
    {
      id: 'b5',
      name: '伊藤 城那',
      instrument: 'ボール',
      image: 'https://i.imgur.com/WrTvaYf.jpg'
    },
    {
      id: 'c1',
      name: '小池 良',
      instrument: 'シガーボックス',
      image: 'https://i.imgur.com/bNEmPpp.png'
    },
    {
      id: 'c2',
      name: '村田 啓人',
      instrument: ' ボール',
      image: 'https://i.imgur.com/WrTvaYf.jpg',
      prize: '3位'
    },
    {
      id: 'c3',
      name: '田邊 慎史',
      instrument: 'ディアボロ',
      image: 'https://i.imgur.com/eKL3doW.png'
    },
    {
      id: 'c4',
      name: '松永 将汰',
      instrument: 'シガーボックス',
      image: 'https://i.imgur.com/bNEmPpp.png',
      prize: '2位'
    },
    {
      id: 'c5',
      name: '西川 歩美',
      instrument: 'ボール',
      image: 'https://i.imgur.com/WrTvaYf.jpg'
    },
    {
      id: 'd1',
      name: '伊達',
      instrument: 'クラブ',
      image: 'https://i.imgur.com/mkNGl7I.png',
      prize: '3位'
    },
    {
      id: 'd2',
      name: '深谷 詩穂',
      instrument: 'シガーボックス',
      image: 'https://i.imgur.com/bNEmPpp.png'
    },
    {
      id: 'd3',
      name: '竹内 優稀',
      instrument: 'ディアボロ',
      image: 'https://i.imgur.com/eKL3doW.png'
    },
    {
      id: 'd4',
      name: '山本 孝',
      instrument: 'ディアボロ',
      image: 'https://i.imgur.com/eKL3doW.png',
      prize: '1位'
    },
    {
      id: 'd5',
      name: '覚井 優希',
      instrument: ' ボール',
      image: 'https://i.imgur.com/WrTvaYf.jpg',
      prize: '審査委員長賞'
    }
  ]
}

const judges = [
  {
    name: '福澤勇帆',
    description: '最近は大学で日本語の歴史を教えています',
    image: 'https://imgur.com/9S2w28p.jpg'
  },
  {
    name: '榊原教貴',
    description: '2011年マラバリスタ入会。\nメインの道具はボールだったが、 最近はダンスに活動の場を移している。\nかつては某アイドルZを真似た演技を披露したりもしていたらしい。\n・MJF2014 観客賞\n・MJF2015 2位（with 山本将平）\n・JJF2013, JJF2014（with 加藤侑大） CS出場\n・MJF2013 おどうぐがかり（with 加藤侑大）',
    image: 'https://i.imgur.com/3KBWTil.jpg'
  },
  {
    name: '平岩和也',
    description: '1993年6月15日生まれ。\n2012年にマラバリスタに入会し、同時にジャグリングを始める。得意な道具はディアボロ。\nMJFの舞台に立つのはジュニア部門、開演前の諸注意説明に続き3度目。\n審査員は始めての経験。\n\n略歴\n・静岡ディアボロコンテスト2014ジュニア部門3位\n・静岡ディアボロコンテスト2015テクニカル部門6位',
    image: 'https://i.imgur.com/SAFBiGe.jpg'
  },
  {
    name: '山本将平',
    description: '2012年度入会。シガーボックスに嗜みがある。得意なじゃんけんはグー。\n\n古来より「やましょー」の愛称で親しまれている。\n\n黎明期は『いやどう考えてもカタカナの方がカッコイイだろ』という理由から自身ではカタカナ表記の「ヤマショー」を使用する場合が多かったようだが、大学入学後、徐々に現在のひらがな表記に移行していった。移行の理由について専門家は『逆にひらがなの方が飾ってなくてかっこいい気がしてきたのではないか』と分析している。\n\nMJF2015シニア部門 準優勝\n第五回関東学生ジャグリング大会チーム部門 優勝',
    image: 'https://i.imgur.com/ziW2EAm.jpg'
  },
  {
    name: '丸山修平',
    description: '2013年度入会。\nクラブを投げたりしてました。',
    image: 'https://i.imgur.com/jUZKQJ0.jpg'
  }
]

const guests = [
  {
    name: '神庭広希',
    description: '神庭広希（かんばひろき）\n\n1993 年生まれ。中学生よりジャグリングを始める。\n2014年のながめくらしつ出演を契機に集団でのジャグリングに興味を持ち始め、舞台やイベントで活動している。\n最近は映像媒体や物を光らせることにも興味がある。\n\nながめくらしつ「心を置いて飛んでいく」演出助手\nながめくらしつ「誰でもない」・秘密基地・Zen-Nokan「Round Reflection」出演',
    image: 'https://i.imgur.com/uqU6U2X.jpg'
  }
]

export {
  contents,
  criterion,
  players,
  judges,
  guests
}



// WEBPACK FOOTER //
// ./src/data/data.js